const errors = {
  GENERIC_ERROR: 'generic-error',
  UNAUTHORIZED: 'unauthorized',
  VALIDATION_ERROR: 'validation-error',
  DEPENDENCY_ERROR: 'dependency-error',
  UNEXPECTED_ERROR: 'unexpected-error',
  INVALID_COUPON: 'invalid-coupon',
  CHARGE_ERROR: 'charge-error',
  FETCH_FAILURE: 'fetch-failure',
  JSON_PARSE_ERROR: 'json-parse-error',
  NOT_FOUND: 'not-found',
};

export default errors;
